module.exports = "/_next/static/images/dda3d69dfacf1bc863b3d7be7861543d-open-graph-mgm.jpg.webp";